import { AccountCredentials, AccountCreation } from '@/types/account'
import { BASE_URL } from 'api/ApiGlobalInterface'

export const fetchErrorResponse = {
  ok: false,
  statusCode: 500,
  statusMessage: "Couldn't reach the server",
  message: 'error'
}

export const AccountRegister = async (
  formAccount: AccountCreation
): Promise<any> => {
  try {
    const response = await fetch(`${BASE_URL}/accounts`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formAccount)
    })
    let message: string | null = null

    const contentType = response.headers.get('content-type') ?? ''
    if (!response.ok && contentType.includes('application/json')) {
      const errorBody = await response.json()
      message = errorBody.message ?? null
    }

    return {
      ok: response.ok,
      statusCode: response.status,
      statusMessage: response.statusText,
      message
    }
  } catch (e) {
    console.log('error: ', e)
    return fetchErrorResponse
  }
}

export const AccountRead = async (accessToken: string): Promise<any> => {
  try {
    const response = await fetch(`${BASE_URL}/accounts`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    })

    const message = response.ok
      ? <AccountCreation>await response.json()
      : (await response.json()).message

    return {
      ok: response.ok,
      statusCode: response.status,
      statusMessage: response.statusText,
      message
    }
  } catch {
    return fetchErrorResponse
  }
}

export const SessionLogin = async (login: AccountCredentials): Promise<any> => {
  try {
    const response = await fetch(`${BASE_URL}/sessions/website`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        email: login.email,
        password: login.password
      })
    })

    const responseJson = await response.json().catch(() => ({}))

    const accessToken = response.ok
      ? <string>response.headers.get('Authorization')
      : ''
    const refreshToken = response.ok ? <string>responseJson.refreshToken : ''
    const message = response.ok
      ? { accessToken, refreshToken }
      : responseJson.message || 'inexpected error'

    return {
      ok: response.ok,
      statusCode: response.status,
      statusMessage: response.statusText,
      message
    }
  } catch {
    return fetchErrorResponse
  }
}

export const SessionLogout = async (accessToken: string): Promise<any> => {
  try {
    const response = await fetch(`${BASE_URL}/sessions/website`, {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    })

    const newAccessToken = response.ok
      ? <string>response.headers.get('Authorization')
      : ''
    const newRefreshToken = response.ok
      ? <string>(await response.json()).refreshToken
      : ''
    const message = response.ok
      ? { accessToken: newAccessToken, refreshToken: newRefreshToken }
      : (await response.json()).message
    return {
      ok: response.ok,
      statusCode: response.status,
      statusMessage: response.statusText,
      message
    }
  } catch {
    return fetchErrorResponse
  }
}

export const SessionTokenRefresh = async (
  refreshToken: string
): Promise<any> => {
  try {
    const response = await fetch(`${BASE_URL}/sessions/website`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${refreshToken}`
      }
    })
    const newAccessToken = response.ok
      ? <string>response.headers.get('Authorization')
      : ''
    const newRefreshToken = response.ok
      ? <string>(await response.json()).refreshToken
      : ''
    const message = response.ok
      ? { accessToken: newAccessToken, refreshToken: newRefreshToken }
      : (await response.json()).message
    return {
      ok: response.ok,
      statusCode: response.status,
      statusMessage: response.statusText,
      message
    }
  } catch {
    return fetchErrorResponse
  }
}
